import { h } from 'preact';

const Banner = ({ onClose }) => (
  <div className="bg-[#f9f8f8]">
    <div className="flex items-center justify-center sm:flex-nowrap flex-wrap">
         <img 
          src="https://cdn.shopify.com/s/files/1/0689/2647/2508/files/20250325_Shopify_CustomizerLogo_525x197_bfb2a9a1-2c6a-4823-96c3-db8e097aedf8.png"
          alt="Customizer it!"
          width={350}
        >
         </img>

      <h2 className="sm:text-20 pb-10 sm:pb-0 text-faded-black text-center font-franklin text-16 pl-10 pr-10">
        CHOOSE A{' '}
        <span className="font-weight-bold">
          SHIRT
          <br /> STYLE
        </span>{' '}
        FOR YOUR ART
      </h2>
    </div>
    <button
      onClick={onClose}
      className="absolute right-8 top-8 font-franklin text-12 hover:underline"
    >
      CLOSE X
    </button>
  </div>
);

export default Banner;
